// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"361decb0","292":"c8c51da1","350":"b46be700","453":"9cd3def4","732":"d6300edd"}[chunkId] + ".chunk.js";
};